export default __webpack_public_path__ + "static/media/left-man.a34259db.png";